import CreateItemButton from "components/buttons/create";
import { List, Icon } from "components";
import { PermissionGate } from "permissions/components/gate";
import React from "react";
import { useParams } from "react-router-dom";
import MilestoneFilters from "@/modules/work/projects/milestones/filters";
import { DateCell } from "@/modules/work/billables/cells";
import { StatusCell } from "@/components/status/cell";
import HeaderPortal from "components/portal/header-portal";
import { EmployeeCell } from "components/cell/employee/cell";
import { ROUTE } from "@/lib/utils";
import { BILLABLE } from "icons/src";

export default function JobMilestones() {
  const { jobId } = useParams();

  const fields = [
    "id",
    "name",
    "status",
    "coordinator.id",
    "coordinator.first_name",
    "coordinator.last_name",
    "coordinator.avatar",
    "start_date",
    "end_date",
    "billable",
  ];
  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
    },
    {
      id: "coordinator",
      header: "MC",
      accessorKey: "coordinator",
      cell: EmployeeCell,
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "start_date",
      header: "Start Date",
      accessorKey: "start_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "end_date",
      header: "End Date",
      accessorKey: "end_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "billable_link",
      header: "Billable",
      accessorKey: "billable",
      href: (row) => row.billable ? ROUTE.BILLABLE(row.billable) : null,
      linkProps: { target: "_blank", rel: "noopener noreferrer" },
      cell: ({ row }) => {
        const billableId = row.original.billable;
        if (!billableId) return null;
        return (
          <div className="text-muted-foreground hover:text-black">
            <Icon icon={BILLABLE} />
          </div>
        );
      },
    },
  ];

  const defaultFilters = {
    job: {
      _eq: jobId,
    },
  };

  return (
    <div className="flex-1 overflow-auto">
      <HeaderPortal>
        <PermissionGate
          rule="create:PC,SC,JC,AM"
          collection="milestones"
          showWhenDisabled={false}
        >
          <CreateItemButton href>Milestone</CreateItemButton>
        </PermissionGate>
      </HeaderPortal>
      <List
        title="Milestones"
        storageKey={jobId}
        endPoint="milestones"
        filters={defaultFilters}
        columns={columns}
        meta={{ fields }}
        href={(item) => ROUTE.MILESTONE(item.id)}
        renderFilters={MilestoneFilters}
      />
    </div>
  );
}
